export enum DefaultColorEnum {
    Cor = '#8199CD',
    Acesso = 'white',
    NaoAcesso = '#E0E0E0'
}